
import { css } from 'lit';
export default css`
q, q.default, blockquote, blockquote.default {
  display: flex;
}
  q, q.default, blockquote, blockquote.default {
  border-width: 0px;
}
  q, q.default, blockquote, blockquote.default {
  border-left-width: 3px;
}
  q, q.default, blockquote, blockquote.default {
  border-style: solid;
}
  q, q.default, blockquote, blockquote.default {
  --tw-border-opacity: 1;
  border-color: rgba(107, 31, 153, var(--tw-border-opacity));
}
  q, q.default, blockquote, blockquote.default {
  padding-left: 2rem;
}
  q, q.default, blockquote, blockquote.default {
  padding-top: 1rem;
}
  q, q.default, blockquote, blockquote.default {
  padding-bottom: 0.25rem;
}
  q, q.default, blockquote, blockquote.default {
  font-family: adobe-caslon-pro, Adobe Caslon Pro, EB Garamond, serif;
}
  q, q.default, blockquote, blockquote.default {
  font-size: 2.5rem;
}
  q, q.default, blockquote, blockquote.default {
  font-weight: 500;
}
  q, q.default, blockquote, blockquote.default {
  line-height: 1.2;
}
  q,
  q.default,
  blockquote,
  blockquote.default {
    max-width: 600px;
  }
  q p, q.default p, blockquote p, blockquote.default p {
  font-size: 2.5rem;
}
  q p, q.default p, blockquote p, blockquote.default p {
  line-height: 1.2;
}
  @media (min-width: 1024px) {
  q p, q.default p, blockquote p, blockquote.default p {
    font-size: 2.8125rem;
  }
}
  q::before, q.default::before, blockquote::before, blockquote.default::before {
      content: "";
    }
  @media (min-width: 1024px) {
  q, q.default, blockquote, blockquote.default {
    font-size: 2.8125rem;
  }
}
  q.testimonial, blockquote.testimonial {
  position: relative;
}
  q.testimonial, blockquote.testimonial {
  padding-top: 5.5rem;
}
  q.testimonial::before, blockquote.testimonial::before {
  position: absolute;
}
  q.testimonial::before, blockquote.testimonial::before {
  top: 0px;
}
  q.testimonial::before, blockquote.testimonial::before {
  left: 0px;
}
  q.testimonial::before, blockquote.testimonial::before {
  height: 5rem;
}
  q.testimonial::before, blockquote.testimonial::before {
  width: 5rem;
}
  q.testimonial::before, blockquote.testimonial::before {
      position: absolute;
      content: "";
      background-image: url('data:image/svg+xml;utf8,<svg class="fill-current text-purple" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><path fill="%236b1F99" d="M26.196 36.843c.79-3.273 2.086-7.373 3.884-12.301 1.835-4.964 3.705-9.478 5.611-13.542h11.816c-2.374 9.604-4.19 18.613-5.45 27.03H26.951l-.755-1.187zM1 36.843c.791-3.273 2.086-7.373 3.885-12.301 1.834-4.964 3.704-9.478 5.61-13.542h11.816c-2.374 9.604-4.19 18.613-5.45 27.03H1.756L1 36.843z"/></svg>');
    }
  q.testimonial p, blockquote.testimonial p {
  font-family: adobe-caslon-pro, Adobe Caslon Pro, EB Garamond, serif;
}
  q.testimonial p, blockquote.testimonial p {
  font-size: 1.5rem;
}
  q.testimonial p, blockquote.testimonial p {
  font-weight: 500;
}
  q.testimonial p, blockquote.testimonial p {
  line-height: 1.5;
}
  @media (min-width: 1024px) {
  q.testimonial p, blockquote.testimonial p {
    font-size: 1.625rem;
  }
}
  q.testimonial p.attribution, blockquote.testimonial p.attribution {
  font-family: Lato, sans-serif;
}
  q.testimonial p.attribution, blockquote.testimonial p.attribution {
  font-size: 1.25rem;
}
  q.testimonial p.attribution, blockquote.testimonial p.attribution {
  font-style: italic;
}
  @media (min-width: 1024px) {
  q.testimonial p.attribution, blockquote.testimonial p.attribution {
    font-size: 1.375rem;
  }
}
  q.testimonial p.attribution::before, blockquote.testimonial p.attribution::before {
  margin-right: 0.5rem;
}
  q.testimonial p.attribution::before, blockquote.testimonial p.attribution::before {
  display: inline-block;
}
  q.testimonial p.attribution::before, blockquote.testimonial p.attribution::before {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
}
  q.testimonial p.attribution::before, blockquote.testimonial p.attribution::before {
  vertical-align: middle;
}
  q.testimonial p.attribution::before, blockquote.testimonial p.attribution::before {
        content: '';
        height: 2.5px;
        width: 8px;
      }
`;